import React, { Component } from 'react';

export default class extends Component {
  render() {
    if (!this.props.error) return;

    return (
      <div className="banner banner-danger">
        <p className="icon text-center">
          <span className="blade-x"></span>
        </p>
        <p className="message">
          {this.props.error}
        </p>
      </div>
    );
  }
}